import { SecondaryData } from '@strata/react-grid';

export const scriptCountBreakdownColumns = [
    { accessorKey: 'exception', header: 'Exception', size: 280 },
    { accessorKey: 'prescriptions', header: 'Prescriptions', size: 120 },
];

export const treatmentsNotFoundColumns = [
    {
        accessorKey: 'source',
        header: 'Source',
        size: 180,
        cell: ({ getValue }) => <SecondaryData data={getValue()} />,
    },
    { accessorKey: 'prescriptions', header: 'Prescriptions', size: 120 },
];

export const scriptCountBreakdownSortDefaults = [{ id: 'exception', desc: false }];

export const treatmentsNotFoundSortDefaults = [{ id: 'source', desc: false }];
